import * as TwcListActions from './list';
import * as TwcAddActions from './add';
import * as TwcListCategoriesActions from './listCategories';
import * as TwcExcelList from './insertExcel';

const Actions = {
  ...TwcListActions,
  ...TwcAddActions,
  ...TwcListCategoriesActions,
  ...TwcExcelList,
};

export default Actions;
